import { Icon } from '@iconify/react';
import { useCallback, useEffect, useState } from 'react';
// material
import {
  Autocomplete,
  Box,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import searchFill from '@iconify/icons-eva/search-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import { useDispatch } from 'react-redux';
import { DateRangeStyled, RootStyle, SearchStyle } from '../Global/Styling';
// ---------------------------------------------------------
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { fDate } from '../../utils/formatTime';
// ----------------------------------------------------------------------

import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import { getCityData, getLoanTypeData, getStatusList } from '../../store/Slice/Global/GlobalSlice';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';

export default function RecommendationToolbar({
  filterName,
  setFilterName,
  onFilterName,
  filterDatesRange,
  setFilterDatesRange,
  filterState,
  setFilterState
}) {
  const dispatch = useDispatch();
  const [isOpenFilter, openFilter] = useState(false);

  const { LoginData } = useLoginSelector();
  const { CityDrop, LoanTypeDrop, StatusDrop } = useGlobalSelector();

  const handleRemoveFilter = (e) => {
    setFilterDatesRange([
      {
        startDate: null,
        endDate: null,
        key: 'selection'
      }
    ]);
    setFilterState({
      ...filterState,
      product: ' ',
      productId: null,
      city: null,
      cityId: null,
      status: ' ',
      statusId: null
    });
    setFilterName('');
  };

  const getLoanMasterApi = useCallback(() => {
    const obj = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId
    };
    dispatch(getLoanTypeData(obj));
  }, [LoginData]);

  //  city api
  const handleGetState = useCallback(
    (optionVal) => {
      const data = {
        ...(optionVal && { stateId: optionVal }),
        companyId: LoginData?.companyId,
        userId: LoginData?.userId,
        searchLiteral: '',
        sortOrder: 'desc'
      };

      dispatch(getCityData(data)); // fetch city data
    },
    [LoginData?.companyId, LoginData?.userId] // dependencies
  );

  useEffect(() => {
    getLoanMasterApi(); // loan master list
    handleGetState(null); // city list
    dispatch(getStatusList(58)); // status list
  }, []);

  return (
    <>
      {isOpenFilter && (
        <Box px={3} pt={2}>
          <Grid container spacing={3}>
            <Grid item xs>
              <Select
                fullWidth
                value={filterState.product}
                onChange={(e) => {
                  const prevData = filterState;
                  const inputVal = JSON.parse(e.target.value);
                  prevData.product = e.target.value;
                  prevData.productId = inputVal.loanId;
                  setFilterState({ ...filterState, prevData });
                }}
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${filterState.product}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Product
                </MenuItem>
                {LoanTypeDrop?.map((productItem, productIndex) => (
                  <MenuItem key={productItem?.value} value={productItem?.value}>
                    {productItem.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs sx={{ position: 'relative' }}>
              <Box className="displayDateRange">
                {filterDatesRange[0].startDate !== null
                  ? `${fDate(filterDatesRange[0].startDate)} to `
                  : ''}
                {filterDatesRange[0].endDate !== null ? fDate(filterDatesRange[0].endDate) : ''}
                {filterDatesRange[0].startDate === null && filterDatesRange[0].endDate === null ? (
                  <Typography className="dissabledMenu">Select Date Range</Typography>
                ) : (
                  ''
                )}
              </Box>
              <Select
                fullWidth
                inputProps={{
                  className: 'textInput'
                }}
                MenuProps={{
                  className: 'menuOpened'
                }}
                value=" "
                className="datesSelect"
                style={{ width: '230px' }}
              >
                <DateRangeStyled
                  editableDateInputs={false}
                  onChange={(item) => setFilterDatesRange([item.selection])}
                  moveRangeOnFirstSelection={false}
                  ranges={filterDatesRange}
                  className="dateRangePicker"
                />
              </Select>
            </Grid>
            <Grid item xs>
              <Autocomplete
                disablePortal
                id="combo-box-demo8"
                size="small"
                options={CityDrop || []}
                getOptionLabel={(option) => (option.label ? option.label : option.label)}
                renderOption={(props, option) => <li {...props}>{option.label}</li>}
                renderInput={(params) => (
                  <TextField {...params} fullWidth placeholder="Select City" />
                )}
                value={filterState !== null ? filterState.city : null}
                onChange={(e, newValue) => {
                  const prevData = filterState;
                  prevData.city = newValue !== null ? newValue : null;
                  prevData.cityId = newValue !== null ? newValue.value : null;
                  setFilterState({ ...filterState, prevData });
                }}
              />
            </Grid>
            {/* <Grid item xs>
              <Select
                fullWidth
                value={filterState.status}
                onChange={(e) => {
                  const prevData = filterState;
                  const inputVal = JSON.parse(e.target.value);
                  prevData.status = e.target.value;
                  prevData.statusId = inputVal.stageStatusId;
                  setFilterState({ ...filterState, prevData });
                }}
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${filterState.status}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Status
                </MenuItem>
                {StatusDrop?.map((productItem, productIndex) => (
                  <MenuItem key={productItem?.value} value={productItem?.value}>
                    {productItem.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid> */}
            <Grid item xs="auto">
              <Tooltip title="Reset Filter">
                <IconButton
                  sx={{ padding: '0', paddingTop: '0.4rem', paddingBottom: '0.4rem' }}
                  onClick={(e) => {
                    handleRemoveFilter(e);
                  }}
                >
                  <FilterListOffIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      )}

      <RootStyle
        sx={{
          minHeight: 45,
          borderBottom: '1px solid #eaedf1',
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      >
        <Box>
          <SearchStyle
            value={filterName}
            onChange={onFilterName}
            placeholder="Search Application"
            classes={{
              root: 'searchHolder',
              input: 'searchInput'
            }}
            startAdornment={
              <InputAdornment position="start">
                <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            }
          />
          &nbsp;&nbsp;&nbsp;
          <Tooltip title="Filter list">
            <IconButton
              onClick={(e) => {
                if (isOpenFilter) {
                  openFilter(false);
                } else {
                  openFilter(true);
                }
              }}
            >
              <Icon icon={roundFilterList} />
            </IconButton>
          </Tooltip>
        </Box>
      </RootStyle>
    </>
  );
}
